//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Annotations.js";
import "../no/ugmath.js";
let d=[[[0,"BarcodeHeight",1,0],[0,"Basepoint",1,0],[0,"ColorPicker",1,0],[0,"TargetObject",1,"Plane",0]],[[["origin"],"SetManipulatorOrigin",{},1,0],[["orientation"],"SetManipulatorOrientation",{},1,0],[[],"GetBarcodeTag",{R_:{barcodeTag:"Annotations.SimpleDraftingAid"}},0,0],[["barcodeTag"],"SetBarcodeTag",{},1,0],[[],"IsMultipleBarcodes",{R_:{isMultipleBarcodes:''}},0,0],[["isMultipleBarcodes"],"SetIsMultipleBarcodes",{},1,0],[[],"IsBarcodeQualified",{R_:{qualify:''}},0,0],[["qualify"],"SetBarcodeQualified",{},1,0],[[],"UpdateBarCode",{},0,0],[["angle"],"RotateBarCodeAroundZ",{},1,0]],[]];
SPLM.Tooling.InsertBarcodeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.InsertBarcodeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;